import { render, staticRenderFns } from "./SMSPanel.vue?vue&type=template&id=923e6be8&scoped=true&"
import script from "./SMSPanel.vue?vue&type=script&lang=js&"
export * from "./SMSPanel.vue?vue&type=script&lang=js&"
import style0 from "./SMSPanel.vue?vue&type=style&index=0&id=923e6be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923e6be8",
  null
  
)

export default component.exports